import { Button, Card, Loader, Typography } from '@bharatpe/bharat-ui';
import React, { useEffect, useState } from 'react';
import { IApproveToPayTab, ICollectRequestDetails } from 'types';
import { formatDateDynamic, isEmpty } from 'utils/Utils';
import noTransactionsIcon from 'assets/images/autoPay/noTransactionsIcon.svg';
import { SET_COLLECT_REDIRECTION_PAGE, SET_PENDING_MANDATE_COLLECT_REQUEST, useUpiData } from 'Slices';
import { CollectAuth } from 'utils/nativeUpiHandler';
import history from 'utils/History';
import Toasty from 'components/atoms/Toasty';
import { useDispatch } from 'react-redux';

const PendingTab: React.FC<IApproveToPayTab> = ({ paymentRequestItem, transactionLoading, reloadTransactions }) => {
	const profileDetails = useUpiData();
	const bankList = profileDetails?.upiProfileDetails?.user_banks || [];
	const dispatch = useDispatch();

	const declineButtonHandler = async (declineItem: ICollectRequestDetails) => {
		try {
			const data: ICollectRequestDetails = await CollectAuth(declineItem, '', bankList[0], 'R');
			if (data) {
				reloadTransactions();
			}
		} catch (err: any) {
			Toasty.error('Something went wrong!!');
		}
	};
	const approveButtonHandler = async (approveItem: ICollectRequestDetails) => {
		dispatch(SET_COLLECT_REDIRECTION_PAGE('/account/approve-to-pay'));
		dispatch(SET_PENDING_MANDATE_COLLECT_REQUEST(approveItem));
		history.push({ pathname: '/upi/collect-auto-pay-details' });
	};

	if (paymentRequestItem == undefined || isEmpty(paymentRequestItem))
		return (
			<div className="mx5 mt6 mandate-list text-center">
				<Card className="p4 mb5 mt5 flex flex-column flex-center mb4">
					<img src={noTransactionsIcon} />
					<Typography variant="Bold500">No transactions</Typography>
					<Typography variant="Light200" className="grey mt2">
						You haven’t made any transactions yet
					</Typography>
				</Card>
			</div>
		);

	return (
		<div className="mx5 mt6 mandate-list text-center">
			{paymentRequestItem?.map((item: ICollectRequestDetails, idx: number) => {
				return (
					<Card className="p4 mb5 mt5 flex flex-column flex-center mb4 mandate-pending__box" key={idx}>
						<div className="flex flex-row flex-justify flex-center width-100">
							<div className="flex flex-row">
								<img src={item?.payee_details?.payee_logo} className="circular-logo" />
								<div className="ml2 flex-start width-75">
									<Typography variant="Regular300" className="text-ellipsis1 text-left">
										{item?.payee_details?.name}
									</Typography>
									<Typography variant="Regular100" className="grey mt1 text-ellipsis text-left">
										{item?.payee_details?.vpa}
									</Typography>
								</div>
							</div>
							<Typography variant="Bold400" className="grey mt1 text-ellipsis text-left">
								₹{item?.amount}
							</Typography>
						</div>
						<div className="flex flex-row flex-justify flex-center width-100 mt4">
							<Typography variant="Regular200" className="text-ellipsis1 width-50 text-left grey">
								Accept before {formatDateDynamic(item?.expire_after, `DD MMM' YYYY,  h:mm a`)}
							</Typography>
							<div className="flex flex-row flex-center width-50">
								<Button
									variant="outlined"
									color="danger"
									className="mr2 btn-deny"
									onClick={() => declineButtonHandler(item)}>
									DENY
								</Button>

								<Button className="btn-approve" onClick={() => approveButtonHandler(item)}>
									APPROVE
								</Button>
							</div>
						</div>
					</Card>
				);
			})}
		</div>
	);
};
export default PendingTab;
